import { render } from "./SelectMenu.vue?vue&type=template&id=fc31107e"
import script from "./SelectMenu.vue?vue&type=script&lang=js"
export * from "./SelectMenu.vue?vue&type=script&lang=js"

import "./SelectMenu.vue?vue&type=style&index=0&id=fc31107e&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__